import styled from 'styled-components';

import Button from '@components/Button';

export const GuestWrapper = styled.div`
  max-height: 300px;
  padding: 5px 15px;
  overflow-y: auto;
  width: 100%;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 0px;
    max-height: none;

    .flightGuestBox__counter {
      justify-content: flex-end;
    }
  }
`;

export const GuestFooter = styled.div<{ alignRight?: boolean }>`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0px;
  }
`;

export const ApplyButton = styled(Button)`
  width: 135px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 200px;
  }
`;

export const DynamicRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-direction: column;
    justify-content: space-between;
    height: 90px;
    margin-top: 20px;
  }
`;

export const GuestBoxWrapper = styled.div`
  & > div {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }
`;

export const ErrorMessageWrapper = styled.div`
  padding: 10px 10px;
  background-color: rgba(224, 35, 27, 0.1);
  color: ${({ theme }) => theme.palette.coral};
`;

export const ErrorMessageContent = styled.div`
  display: flex;
  align-items: center;
`;

export const AddRoom = styled.span`
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.palette.brownishGrey};
`;
